import { render, staticRenderFns } from "./dashboard-main.html?vue&type=template&id=7fcb747c&scoped=true&external"
import script from "./dashboard-main.js?vue&type=script&lang=js&external"
export * from "./dashboard-main.js?vue&type=script&lang=js&external"
import style0 from "./dashboard-main.scss?vue&type=style&index=0&id=7fcb747c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcb747c",
  null
  
)

export default component.exports